import Vue from "vue";
import VueI18n from "vue-i18n";
Vue.use(VueI18n);


// import yn_existed from "./config/yn";
// const yn = Object.assign(window.yn_append, yn_existed); 

// 引入各个语言配置文件
import zh from "./config/zh";
import en from "./config/en";
// import yn from "./config/yn";
// import tai from "./config/tai";
// import hindi from "./config/hindi";
// import malay from "./config/malay";
// import spain from "./config/spain";
// import italian from "./config/italian";
// import arabic from "./config/arabic";
// import zhtw from "./config/zhtw";
// import Indonesia from "./config/Indonesia";

// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言
    locale: "zh", // 语言标识
    fallbackLocale: 'zh', //如果没有找到要显示的语言，则默认显示 ‘en’
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        zh,en
    },
    silentTranslationWarn: true
});
// 暴露i18n
export default i18n;